import { FormGroup } from '@angular/forms';
import { FieldsToBeEdited, Leg } from '@approot/models';
import { optionsChangeHandler } from './leg.utilities';

export function setCurrencyWithPreSetPosition(
  currency: string,
  form: FormGroup,
  leg: Leg
) {
  if (form.get(currency)) {
    form.get(currency).setValue(leg.preSetPosition[currency]);
  }
}

export function faceCurrencyChange(
  form: FormGroup,
  presetsLoaded: boolean,
  fieldsToBeEdited: FieldsToBeEdited,
  leg: Leg,
  fieldNumber: '' | '1' | '2' = ''
): void {
  if (
    form.get('faceCurrency' + fieldNumber) &&
    form.get('notional' + fieldNumber) &&
    form.get('counterNotional' + fieldNumber)
  ) {
    const cross = presetsLoaded
      ? form.get('cross')?.value
      : leg.preSetPosition?.cross;

    if (cross) {
      const faceCurrency =
        fieldsToBeEdited?.['notional' + fieldNumber] === 'counterNotional'
          ? cross.substring(0, 3)
          : cross.substring(3, 6);
      form.get('faceCurrency' + fieldNumber).setValue(faceCurrency);
    }
  }
}

export function setCurrencyOptions(
  options: string[],
  form: FormGroup,
  leg: Leg
): void {
  if (form.get('currency')) {
    optionsChangeHandler(form, leg, 'currency', options, ''); // clear the dropdown options
  }
}
